/**
 * Palette de graphiques mappée sur les tokens du design system Flash Pay
 * (le template d'origine utilisait des variables `--chart-1..5` inexistantes ici).
 */
export const CHART_TOKENS = {
  brand: "--brand-500",
  accent: "--accent",
  success: "--success",
  warning: "--warning",
  info: "--info",
  destructive: "--destructive",
  primary: "--primary",
} as const;

export type ChartToken = keyof typeof CHART_TOKENS;

export const chartColor = (token: ChartToken, alpha?: number): string =>
  alpha === undefined
    ? `hsl(var(${CHART_TOKENS[token]}))`
    : `hsl(var(${CHART_TOKENS[token]}) / ${alpha})`;
